import React, { Component } from 'react';
import { withRouter } from 'react-router';
import ErrorBoundary from '../../ErrorBoundary';
import PropTypes from 'prop-types';

// import { Scrollbars } from 'react-custom-scrollbars';

import { connect } from 'react-redux';
import * as actions from '../../actions';
// import * as portsData from '../../data/ports.json';

import styled, { createGlobalStyle } from 'styled-components';

import { Menu, Dropdown, Icon, Input, Tooltip } from 'antd';
import { isEmpty } from '../../util/isEmpty';
import { tryParseJSON } from '../../util/tryParseJSON';
import {
  SEARCH_PG_DROPDOWN_MAX_HT,
  LANDING_PG_DROPDOWN_MAX_HT,
  SEARCH_PG_AUTOCOMPLETE_MAX_DROPDOWN,
  LANDING_PG_AUTOCOMPLETE_MAX_DROPDOWN,
} from '../../envVariables';
import CustomDropdownRender from '../common/CustomDropdownRender';
import { sortArrObjStr } from '../../util/sortArrObjStr';

const { SubMenu } = Menu;

const GlobalStyleSubMenu = createGlobalStyle`
  body {
     .my-searchbar-menu-submenu-styled.ant-dropdown-menu-submenu-popup {
    max-height: ${(props) =>
      props.dropdownHt ? props.dropdownHt + 'px' : '50vh'}  ;
    overflow-y: auto ;
    overflow-x: hidden ;
  }
  .my-searchbar-menu-submenu-styled.ant-dropdown-menu-submenu-popup ul {
    width: 100%;
  }
  .my-searchbar-menu-submenu-styled.ant-dropdown-menu-submenu-popup ul li{
    width: 190px;
  }
  }
`;

// for landing page close icon to clear input text upon click on it
const StyledCloseIcon = styled.span`
  position: absolute;
  display: inline-flex;
  align-items: center;
  top: 0;
  right: 0;
  height: 100%;
  width: 34px;
  color: #bbc;

  :hover {
    color: rgba(0, 0, 0, 0.65);
  }
`;

const originInputRef = React.createRef();
const destinationInputRef = React.createRef();

/**
 * @component
 * @name CustomDropdown
 * @category Search Page
 * @subcategory Search bar
 * @description This is the custom ports dropdown component (not google maps places dropdown).
 * <br> <br>
 * **Example**
 * ```js
 *   <CustomDropdown  name="origin" placeholder="ORIGIN OF SHIPMENT"/>
 * ```
 */
class CustomDropdown extends Component {
  place_id = '';
  name = '';
  formatted_address = '';
  location = '';

  state = {
    input: '', //make it empty string in production
    places: [],
    countriesArr: [], //for landing page dropdown autocomplete
    // show auto complete when user starts editing input field,
    //otherwise just show multi-level dropdowns
    showAutoComplete: false,
  };

  componentDidMount = () => {
    this.setInput(this.props.queryParams);

  };

  /**
   * @description It shows the selected ports in the origin/destination input field
   * in the format `${city},{country}`, e.g.`Calgary, Canada`
   * <br> <br>
   * **setInput(queryParams) -> {void}**
   * <br><br>
   * **Parameters:**
   * | Name          | Type          | Description  |
   * | :------------ |:------------- | :------------|
   * | queryParams   | Object        | query params |
   * <br> <br>
   * Returns: Type: void
   */
  setInput = (queryParams) => {
    if (this.props.name === 'origin') {
      let from = queryParams.from;
      //check for empty object if isFormSubmitSuccess is true
      // from = {};
      if (from && !isEmpty(from)) {
        //object
        from =
          from.name && `${from.name}${from.country && ','} ${from.country}`;
      } else {
        from = '';
      }

      this.setState(
        {
          input: from,
        },
        this.getCountries
      );
    } else {
      let to = queryParams.to;
      //check for empty object if isFormSubmitSuccess is true
      // to = {};
      if (to && !isEmpty(to)) {
        to = to.name && `${to.name}${to.country && ','} ${to.country}`;
      } else {
        to = '';
      }

      this.setState(
        {
          input: to,
        },
        this.getCountries
      );
    }
  };

  componentWillReceiveProps = (nextProps) => {
    const { queryParams = {} } = nextProps;

    if (this.props.queryParams !== queryParams) {
      // console.log('CWRP custom dropdown');
      this.setInput(queryParams);
      return true;
    }
    return false;
  };

  /**
   * @description It is invoked when user is typing into origin/destination ports input field
   * <br> <br>
   * **onInputChange(e) -> {void}**
   * <br><br>
   * **Parameters:**
   * | Name          | Type          | Description  |
   * | :------------ |:------------- | :------------|
   * | e             | Event         | Mouse event i.e. onchange event  |
   * <br> <br>
   * Returns: Type: void
   */
  //to remove a warning, it tells to provide onChange
  // when search text is getting typed into input field
  onInputChange = (e) => {

    e.preventDefault();

    this.setState(
      { input: e.target.value, showAutoComplete: true },
      this.getCountries
    );
    // console.log('onChange', e.target.value);
  };

  /**
   * @description It is invoked when user clicks on origin/destination ports input field.
   * Its function is to select all text in the input field.
   * <br> <br>
   * **onInputClick(e) -> {void}**
   * <br><br>
   * **Parameters:**
   * | Name          | Type          | Description  |
   * | :------------ |:------------- | :------------|
   * | e             | Event         | Mouse event i.e. onclick event  |
   * <br> <br>
   * Returns: Type: void
   */
  // when input fields are clicked, select the text
  onInputClick = (e) => {

    // console.log(this.props.name);
    const myRef =
      this.props.name === 'origin' ? originInputRef : destinationInputRef;
    myRef.current.setSelectionRange(0, this.state.input.length);
  };

  /**
   * @description It gets all the countries from the port json, which matches the input text.
   * If no text is in input field, then it gets all countries from the port json.
   * <br> <br>
   * **getCountries() -> {void}**
   * <br><br>
   * Returns: Type: void
   */
  getCountries = () => {
    // const isLandingPageExist =
    //   [this.props.location.pathname].filter((o) => o.includes('/landing-page'))
    //     .length !== 0;

    // if (!isLandingPageExist) {
    //   return;
    // }
    const { input, showAutoComplete } = this.state;

    let searchText
    if(input!==undefined){
      searchText= input.trim()
    }
    else{
      searchText= input

    }

    // const searchText = input.trim()
    let portJson = {};

    if (this.props.name === 'origin') {
      portJson = this.props.originPortJSON;
    } else {
      portJson = this.props.destinationPortJSON;
    }

    let countriesSet = new Set();
    let countriesArr = [];
    if (searchText && showAutoComplete) {
      // auto complete
      Array.isArray(portJson.Ports) &&
        portJson.Ports.map((port) => {
          // only allow country or city or both ("city, country" format) which includes search text
          if (
            port.Name.toLowerCase().includes(searchText.toLowerCase()) ||
            port.Country.toLowerCase().includes(searchText.toLowerCase()) ||
            `${port.Name}, ${port.Country}`
              .toLowerCase()
              .includes(searchText.toLowerCase())
          ) {
            countriesSet.add(port.Country);
          }
        });
    } else {
      // when search text is empty
      Array.isArray(portJson.Ports) &&
        portJson.Ports.map((port) => countriesSet.add(port.Country));
    }
    countriesArr = Array.from(countriesSet);
    // check if countries are alresy sorted in alphabetical order
    // console.log(countriesArr);

    this.setState({ countriesArr });
  };

  /**
   * @description It is invoked when user selects a port from dropdown menu items
   * <br> <br>
   * **handleDropdownClick(e) -> {void}**
   * <br><br>
   * **Parameters:**
   * | Name          | Type          | Description  |
   * | :------------ |:------------- | :------------|
   * | e             | Event         | Mouse event i.e. onclick event  |
   * <br> <br>
   * Returns: Type: void
   */

  handleDropdownClick = (e) => {
    if (this.props.isFormSubmitSuccess) {
      return; //form is used, don't allow to edit the fields
    }

    if (this.props.name === 'origin') {
      this.props.setQueryParams({
        ...this.props.queryParams,
        from: tryParseJSON(e.key) || {},
      });
    } else {
      this.props.setQueryParams({
        ...this.props.queryParams,
        to: tryParseJSON(e.key) || {},
      });
    }

    // show dropdown after selecting a port
    this.setState({ showAutoComplete: false });
  };

  /**
   * @description It creates menu for the port dropdown
   * <br> <br>
   * **getMenu(countries) -> {Menu}**
   * <br><br>
   * **Parameters:**
   * | Name          | Type          | Description  |
   * | :------------ |:------------- | :------------|
   * | countries     | Array         | array of countries |
   * <br> <br>
   * Returns: Type: Menu
   */
  getMenu = (countries) => {
    const { originPortJSON, destinationPortJSON } = this.props;

    const portJson =
      this.props.name === 'origin' ? originPortJSON : destinationPortJSON;
    const { input, countriesArr, showAutoComplete } = this.state; //for autocomplete dropdown
    // console.log({ countriesArr });
    // for detecting landing page or search bar page
    const isLandingPageExist =
      [this.props.location.pathname].filter((o) => o.includes('/landing-page'))
        .length !== 0;

    let dropdownHt = isLandingPageExist
      ? LANDING_PG_DROPDOWN_MAX_HT
      : SEARCH_PG_DROPDOWN_MAX_HT;
    dropdownHt = parseInt(dropdownHt || 0);
    dropdownHt = isNaN(dropdownHt) ? undefined : dropdownHt;

    let menu = (
      // <Scrollbars
      //   autoHeight
      //   autoHeightMax={dropdownHt}
      //   style={{
      //     // border: '1px solid #bbc',
      //     boxShadow: '0 0 3px #bbc',
      //     borderRadius: '3px',
      //   }}
      // >
      <Menu
        onClick={this.handleDropdownClick}
        style={{
          // height: 'auto',
          // backgroundColor: 'white',
          maxHeight: `${dropdownHt}px`,
          // boxShadow: '0 0 3px #bbc',
          // borderRadius: '3px',
          overflowY: 'auto',
        }}
      >
        <GlobalStyleSubMenu
        // dropdownHt={dropdownHt}
        />

        {countries.map((country, index) => (
          <SubMenu
            title={country}
            key={index}
            // popupClassName="my-searchbar-menu-submenu"
            popupClassName="my-searchbar-menu-submenu-styled"
          >
            {sortArrObjStr(portJson, 'Ports', 'Name').map(
              (port) =>
                port.Country === country && (
                  <Menu.Item
                    key={JSON.stringify({
                      id: port.id,
                      name: port.Name,
                      country: port.Country,
                      countryId: port.CountryId,
                      linkedPort: port?.linkedPort,
                      portLinked: port?.portLinked,
                      portCode: port?.portCode,
                    })}
                  >
                    <Tooltip
                      placement="right"
                      autoAdjustOverflow
                      title={
                        (port.Name || '').length >= 18 ? port.Name : undefined
                      }
                    >
                      {/* {port.Name} */}
                      {(port.Name || '').length >= 18
                        ? `${port.Name.substring(0, 17)}...`
                        : port.Name}
                    </Tooltip>
                  </Menu.Item>
                )
            )}
          </SubMenu>
        ))}
      </Menu>
      //  </Scrollbars>
    );

    //for autocomplete dropdown only for landing page
    // show only three dropdown in "city, country" format only on landing page
    if (showAutoComplete && `${input}`.trim() && !!input) {
      const MAX_DROPDOWNS = isLandingPageExist
        ? LANDING_PG_AUTOCOMPLETE_MAX_DROPDOWN
        : SEARCH_PG_AUTOCOMPLETE_MAX_DROPDOWN;

      let noOfDropdowns = 0; //init counter for counting autocomplete dropdowns
      menu = (
        <Menu onClick={this.handleDropdownClick}>
          {countriesArr.map(
            (country, index) =>
              Array.isArray((portJson || {}).Ports) &&
              portJson.Ports.map((port) => {
                if (
                  port.Country === country &&
                  // only allow country or city or both ("city, country" format) which includes search text
                  (port.Name.toLowerCase().includes(input.toLowerCase()) ||
                    port.Country.toLowerCase().includes(input.toLowerCase()) ||
                    `${port.Name}, ${port.Country}`
                      .toLowerCase()
                      .includes(input.trim().toLowerCase()))
                ) {
                  ++noOfDropdowns;
                  if (noOfDropdowns > MAX_DROPDOWNS) {
                    return null;
                  }
                  return (
                    <Menu.Item
                      key={JSON.stringify({
                        id: port.id,
                        name: port.Name,
                        country: port.Country,
                        countryId: port.CountryId,
                        linkedPort: port?.linkedPort,
                        portLinked: port?.portLinked,
                        portCode: port?.portCode,
                      })}
                    >
                      {port.Name}, {country}
                    </Menu.Item>
                  );
                }
              })
          )}
        </Menu>
      );
    }

    return menu;
  };

  /**
   * @description It is invoked when user clicks on clear icon ( "X" icon in input field)
   * <br> <br>
   * **onCloseIconClick() -> {void}**
   * <br><br>
   * Returns: Type: void
   */
  onCloseIconClick = () => {
    if (this.props.name === 'origin') {
      this.props.setQueryParams({
        ...this.props.queryParams,
        from: {},
      });
    } else {
      this.props.setQueryParams({
        ...this.props.queryParams,
        to: {},
      });
    }
  };

  render() {
    const {
      originPortJSON,
      destinationPortJSON,
      isFormSubmitSuccess,
      landingPgInputTextColor,
    } = this.props;

    let portJson =
      this.props.name === 'origin' ? originPortJSON : destinationPortJSON;


    //process json
    let countriesSet = new Set();
    !isEmpty(portJson) &&
      !isEmpty(portJson.Ports) &&
      portJson.Ports.map((port) => countriesSet.add(port.Country));
    let countries = Array.from(countriesSet);
    countries = sortArrObjStr(countries, undefined, undefined);

    // for detecting landing page or search bar page
    const isLandingPageExist =
      [this.props.location.pathname].filter((o) => o.includes('/landing-page'))
        .length !== 0;

    // console.log({ isLandingPageExist }, this.props.location.pathname);

    const menu = this.getMenu(countries);
    return (
      <ErrorBoundary>
        <div style={{ position: 'relative' }}>
          <Dropdown
            overlay={
              isFormSubmitSuccess ? (
                <span />
              ) : isEmpty(portJson) ? (
                <Menu>
                  <CustomDropdownRender showSpin={true} />
                </Menu>
              ) : (
                menu
              )
            }
          >
            <div>
              <input
                ref={
                  this.props.name === 'origin'
                    ? originInputRef
                    : destinationInputRef
                }
                type="text"
                placeholder={this.props.placeholder}
                name={this.props.name || ''}
                value={this.state.input || ''}
                onChange={this.onInputChange}
                onClick={this.onInputClick}
                autoComplete="off"
                disabled={isFormSubmitSuccess}
                style={{
                  fontSize: '17px',
                  width: '100%',
                  height: '53px',
                  borderLeft: `1px solid ${this.props.primaryColor}`,
                  borderRight: '0px',
                  borderTop: '0px',
                  borderBottom: '0px',
                  borderRadius: '0px',
                  padding:
                    this.props.name === 'origin'
                      ? '0px 40px 0px 35px'
                      : '0px 30px 0px 48px',
                  textOverflow: 'ellipsis',
                  overflow: 'hidden',
                  outline: '0px',
                  boxShadow: 'none',
                  cursor: isFormSubmitSuccess ? 'default' : 'pointer',
                  backgroundColor: 'white',
                  color: isLandingPageExist && `${landingPgInputTextColor}`,
                }}
              />
              <span
                style={{
                  position: 'absolute',
                  display: 'inline-block',
                  top: 0,
                  left: 0,
                  height: '36px',
                  width: '18px',
                  padding:
                    this.props.name === 'origin'
                      ? '12px 8.5px 8.5px 8.5px'
                      : '12px 8.5px 8.5px 21.5px',
                  fontSize: '24px',
                  color: this.props.secondaryColor,
                  fontStyle: 'normal',
                  cursor: isFormSubmitSuccess ? 'default' : 'pointer',
                }}
              >
                {this.props.name === 'origin' ? 'A' : 'B'}
              </span>
              {!isFormSubmitSuccess && this.state.input && (
                <StyledCloseIcon className="testR1">
                  <Icon
                    type="close-circle"
                    theme="filled"
                    onClick={this.onCloseIconClick}
                    style={{
                      cursor: 'pointer',
                    }}
                  />
                </StyledCloseIcon>
              )}
            </div>
          </Dropdown>
        </div>
      </ErrorBoundary>
    );
  }
}

CustomDropdown.propTypes = {
  /**
   * where it is used in e.g. `origin`
   */
  name: PropTypes.string,
  /**
   * placeholder text
   */
  placeholder: PropTypes.string,
  /**
   * query params
   */
  queryParams: PropTypes.object,
  /**
   * origin ports json
   */
  originPortJSON: PropTypes.object,
  /**
   * destination ports json
   */
  destinationPortJSON: PropTypes.object,
  /**
   * primary color of web app
   */
  primaryColor: PropTypes.string,
  /**
   * secondary color of web app
   */
  secondaryColor: PropTypes.string,
  /**
   * whether to show map beside view-details section
   */
  showOpenMap: PropTypes.bool,
  /**
   * Input text field color on Landing page.
   */
  landingPgInputTextColor: PropTypes.string,
  /**
   * Whether Form is successfully submitted for first time.
   */
  isFormSubmitSuccess: PropTypes.bool,
};

const mapStateToProps = ({ route, code_config, form, cache }) => {
  return {
    queryParams: route.queryParams,
    originPortJSON: route.originPortJSON,
    // originPortJSON: cache.searchOriginPortsData.data,
    destinationPortJSON: route.destinationPortJSON,
    // destinationPortJSON: cache.searchDestinationPortsData.data,
    primaryColor: code_config.primaryColor,
    secondaryColor: code_config.secondaryColor,

    showOpenMap: code_config.showOpenMap,
    landingPgInputTextColor: code_config.landingPgInputTextColor,
    isFormSubmitSuccess: form.isFormSubmitSuccess,
  };
};

export default withRouter(connect(mapStateToProps, actions)(CustomDropdown));
